"use strict";
import * as React from "react";
import { useParams } from "react-router-dom";
import QuickSight from "../common/QuickSight";
import { mainPageInfoList } from "../../_constants/PageInfoList";
import { viewId } from "../../_constants/Code";

const HumanCapitalConfiguration = (props) => {
  const page = mainPageInfoList.find(page => { return page.key === "2"; });
  return (
    <main className="page-container">
      <section className="page-content">
        <div className="centered-container">
          <QuickSight
            pageId={viewId.humanCapitalConfiguration}
            pageInfo={page}
            dashboardList={page.dashboardList}
            listNum={props.params.listNum}
            listNumSub={props.params.listNumSub}
            isKpi={false}
            isBenchmark={false}
          />
        </div>
      </section>
    </main>
  );
};

export default (props) => <HumanCapitalConfiguration {...props} params={useParams()} />;
